export type BlockHeadingTag = "h1" | "h2" | "h3" | "h4" | "h5" | "h6";

type Props = {
    title?: string;
    subTitle?: string;
    HeadingTag: BlockHeadingTag;
};

export const BlockHeader = ({ title, subTitle, HeadingTag }: Props) => {
    if (!title && !subTitle) return null;

    return (
        <div className="px-2">
            {title && (
                <HeadingTag className="pt-2 pb-3 text-3xl font-semibold">
                    {title}
                </HeadingTag>
            )}
            {subTitle && (
                <p className="pb-3 text-xl font-medium text-gray-700">
                    {subTitle}
                </p>
            )}
        </div>
    );
};
